<template>
<v-container
    class="mb-4 pa-5"
    fluid
  >
    <h1 class="display-1 font-weight-bold">
      Community Sites
    </h1>

    <v-container class="d-flex flex-wrap justify-space-around">


      <v-card
        v-for="(site, index) in communitySites"
        :key="index"
        width="350"
        class="ma-2 d-flex flex-column"
        elevation="4"
      >

        <v-img
          v-if="site.imagesrc"
          max-height="200"
          :src="require('../assets/communitysites/' + site.imagesrc)"
        ></v-img>

        <v-card-title>{{ site.name }}</v-card-title>
        <v-card-subtitle>{{ site.subtitle }}</v-card-subtitle>
        <v-card-text>{{ site.description }}</v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn
            :href="site.url"
            target="_blank"
          >
            Visit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

  </v-container>
</template>

<script>
export default {
    name: "HowToStakeWise",
    created() {
      this.randomizeSitesArray();
    },
    methods: {
      randomizeSitesArray() {
        for (let i = this.communitySites.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * i)
          const temp = this.communitySites[i]
          this.communitySites[i] = this.communitySites[j]
          this.communitySites[j] = temp
        }
      }
    },
    data() {
      return {
        communitySites: [{
            name: "Wise beyond Bitcoin",
            imagesrc: "wisebeyondbitcoin.png",
            subtitle: "BEGIN DEFI JOURNEY HERE",
            url: "https://wisebeyondbitcoin.com/",
            description: "We support technologies that promote ethics, equality and Harmonious Solutions. Prior to the emergence of bitcoin, our focus was on the study of money, markets and economics with an emphasis on liberty, social progress and spiritual evolution."
          },
          {
            name: "Wise Answered",
            imagesrc: "wiseanswered.png",
            subtitle: "Stay Wise",
            url: "http://wiseanswered.com/",
            description: "Check back on this website often for any news and updates. This is going to be a fun and rewarding project to support for the long term."
          },
          {
            name: "Wise Simulator",
            imagesrc: "wisesimulator.png",
            subtitle: "THE WISE SIMULATOR PROJECT",
            url: "http://wisesimulator.com/",
            description: "If you are new to digital assets, cryptocurrencies, and blockchain technologies, the learning process typically includes a lot of ice-cream headaches. However, if you compartmentalize topics, learning one step at a time becomes far more enjoyable and manageable. The Wise Simulator Project takes this learning approach. We already know how important and financially beneficial Wise will be for everyone. But how do we help you understand it?"
          },
          {
            name: "wise-token.nl",
            imagesrc: "wise-token.nl.png",
            subtitle: "Be WISE, Become WISE … investeer in de toekomst!",
            url: "https://wise-token.nl/",
            description: "WISE token is de meest eerlijke crypto sinds Bitcoin. Gelanceerd in januari 2021. WISE is gedecentraliseerd (DeFi), heeft Ether als onderpand en een unieke prijsvloer. Het is te vergelijken met een obligatie, heeft veel liquiditeit en geen last van grote investeerders die prijs beïnvloeden. WISE is ontworpen voor exponentiële groei."
          },
          {
            name: "WISETOKEN ITALIA",
            imagesrc: "wisetokenitalia.png",
            subtitle: "",
            url: "http://wisetokenitalia.com/",
            description: "Un token completamente decentralizzato; Una riserva di liquidità senza proprietari; Un valore minimo del token in continua crescita; Nessuna chiave di modifica dello smart contract; Nessuna commissione da parte del team di sviluppo; Un'inflazione sana, calcolata e ridistribuita alla community."
          },
          {
            name: "WISETOKEN SWITZERLAND",
            imagesrc: "wisetokenswitzerland.png",
            subtitle: "Die Zukunft der dezentralisierten Finanzwirtschaft",
            url: "https://www.wise-switzerland.com/",
            description: "Der WISE Token basiert auf einem ERC-20-konformen Smart Contract, der auf der Ethereum-Blockchain entwickelt wurde. Als Blockchain-Token ist WISE eine dezentralisierte, vertrauenslose und hochliquide Kryptowährung."
          },
          {
            name: "wisestats.net",
            imagesrc: "wisestats.png",
            subtitle: "",
            url: "https://wisestats.net/",
            description: "Website provides general stats about Wise token. Get information about a individual address (stakes, number of tokens holding, total usd value, etc..) You can see cumulative charts of starting stakes, ending stakes, penalties paid, rewards gathered. There is also top list of addresses for multiple categories like largest active stakes, share holders, penalties paid, etc..."
          },
          {
            name: "Mobile Staking DApp",
            imagesrc: "wisemobileapp.png",
            subtitle: "Stake WISE with your Smartphone",
            url: "https://wisemobile.app/",
            description: "An alternative staking DApp designed specifically for mobile devices. It is very minimalistic and can be used with the mobile apps MetaMask mobile, Trustwallet or any other app with a DApp browser. It can also be used as a regular staking frontend for Desktops."
          },
          // {
          //   name: "wisestaking.app",
          //   imagesrc: "",
          //   subtitle: "",
          //   url: "http://wisestaking.app/",
          //   description: ""
          // },
        ]
      }
    },
    components: {},
  };
</script>

<style>
</style>
